import { TotalTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/grid-renderers/pinned-row-renderers";
import { formatMessage } from "lib/globalize-util";
import { MetricsKind } from "./types";

export const getMetricKindByLegacyType = (type: TotalTypes): MetricsKind | undefined => {
    if (type === TotalTypes.Units) {
        return MetricsKind.UNITS;
    } else if (type === TotalTypes.Wholesale) {
        return MetricsKind.TOTAL_COST;
    } else if (type === TotalTypes.Retail) {
        return MetricsKind.TOTAL_RETAIL;
    } else if (type === TotalTypes.Skus) {
        return MetricsKind.SKUS;
    } else if (type === TotalTypes.Depth) {
        return MetricsKind.AVERAGE_DEPTH;
    } else if (type === TotalTypes.AvgWholesale) {
        return MetricsKind.AVERAGE_COST;
    } else if (type === TotalTypes.AvgRetail) {
        return MetricsKind.AUR;
    }

    return undefined;
};

export const getLegacyTypeByMetricsKind = (kind: MetricsKind): TotalTypes | undefined => {
    if (kind === MetricsKind.UNITS) {
        return TotalTypes.Units;
    } else if (kind === MetricsKind.TOTAL_COST) {
        return TotalTypes.Wholesale;
    } else if (kind === MetricsKind.TOTAL_RETAIL) {
        return TotalTypes.Retail;
    } else if (kind === MetricsKind.SKUS) {
        return TotalTypes.Skus;
    } else if (kind === MetricsKind.AVERAGE_DEPTH) {
        return TotalTypes.Depth;
    } else if (kind === MetricsKind.AVERAGE_COST) {
        return TotalTypes.AvgWholesale;
    } else if (kind === MetricsKind.AUR) {
        return TotalTypes.AvgRetail;
    }

    return undefined;
};

export const getTotalTypesLabel = (totalType: TotalTypes): string => {
    let totalTypeLabel = "";
    if (totalType === TotalTypes.Units) {
        totalTypeLabel = formatMessage("Units");
    } else if (totalType === TotalTypes.Wholesale) {
        totalTypeLabel = formatMessage("Cost");
    } else if (totalType === TotalTypes.Retail) {
        totalTypeLabel = formatMessage("Retail");
    } else if (totalType === TotalTypes.Skus) {
        totalTypeLabel = formatMessage("Products");
    } else if (totalType === TotalTypes.Depth) {
        totalTypeLabel = formatMessage("Avg Depth");
    } else if (totalType === TotalTypes.AvgWholesale) {
        totalTypeLabel = formatMessage("Avg Cost");
    } else if (totalType === TotalTypes.AvgRetail) {
        totalTypeLabel = formatMessage("AUR");
    }
    return totalTypeLabel;
};
